import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import QAQuestionEntity from "../../../../domain/entities/qa_question.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import QAQuestionDto from "../../../dto/qa_question.dto";

const updateQuestionApiImpl = async (agent: QAQuestionEntity): Promise<Either<ErrorEntity, QAQuestionEntity>> => {
    try {
        console.log("updateQuestionApiImpl", agent);
        const relativeUrl = `/question/${agent.id}`;
        const body = QAQuestionDto.toJSON(agent);
        console.log("check transform", {
            a: agent.agentId, b: agent.agentId != null, c: agent?.agentId?.length, agent, ff: agent.agentId != null && agent.agentId.length > 0,
            tos: agent.agentId?.toString(),
            agent_id: agent.agentId != null && agent.agentId.length > 0 ? parseInt(agent.agentId.toString()) : "",//

        })
        const response = await di.get<HostApi>(HostApiName).put(relativeUrl, body, { contentType: 'application/json' });
        const parsed = QAQuestionDto.fromJSON(response);
        parsed.agentId = agent.agentId;
        return right(parsed);
    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
}

export default updateQuestionApiImpl;